import { render } from "./counterpartyTag.vue?vue&type=template&id=30087666"
import script from "./counterpartyTag.vue?vue&type=script&lang=js"
export * from "./counterpartyTag.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/.pnpm/vue-loader@https+++registry.npmmirror.com+vue-loader+-+vue-loader-17.4.2.tgz_vue@3.2.13_webpack@5.95.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__